var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWait(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 146,
    viewBox: "0 0 102 146",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_561_7275)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M94.1464 103.353C97.2268 117.531 87.015 127.828 87.015 127.828H14.9839C14.9839 127.828 4.77214 117.531 7.85256 103.353C10.933 89.1748 32.6225 81.4104 39.2053 75.5872C45.7881 69.7639 43.4672 59.8475 33.0867 52.2942C22.7061 44.7408 8.65431 39.9303 9.03409 23.5577C9.28727 13.0927 17.5158 6.25671 17.5158 6.25671H84.4832C84.4832 6.25671 92.7539 13.0505 92.9649 23.5577C93.3447 39.9303 79.2929 44.7408 68.9123 52.2942C58.5317 59.8475 56.1687 69.7639 62.7937 75.5872C69.3765 81.4104 91.066 89.1748 94.1464 103.353Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.9731 128.081H14.9842C14.8998 128.081 14.8576 128.039 14.7732 127.997C14.6888 127.912 4.47703 117.447 7.55745 103.269C9.79391 93.0148 21.778 85.9679 30.5129 80.862C34.0575 78.7943 37.1379 76.9798 38.9946 75.3341C41.3998 73.3086 42.7501 70.2282 42.5814 67.0634C42.3704 62.1263 38.8258 56.7672 32.8759 52.463C30.8505 50.9861 28.614 49.5514 26.4619 48.2011C17.6004 42.5888 8.44359 36.7656 8.73898 23.4734C8.99216 12.9662 17.2629 6.0458 17.3473 5.96141C17.3895 5.91921 17.4739 5.87701 17.516 5.87701H84.4835C84.5679 5.87701 84.6101 5.87701 84.6523 5.96141C84.7366 6.0458 93.0073 12.9662 93.2605 23.4734C93.5559 36.7656 84.3991 42.5888 75.5376 48.2011C73.3855 49.5514 71.1491 50.9861 69.1236 52.463C63.1737 56.8094 59.6713 62.1263 59.4182 67.0634C59.2494 70.2282 60.5997 73.2664 63.0049 75.3341C64.8616 76.9798 67.942 78.7521 71.4866 80.862C80.2215 85.9679 92.2056 93.0148 94.4421 103.269C97.5225 117.447 87.3107 127.912 87.2263 127.997C87.1419 128.081 87.0575 128.081 86.9731 128.081ZM15.1108 127.532H86.8887C87.8171 126.52 96.7207 116.603 93.8935 103.395C91.7414 93.3946 79.8839 86.432 71.1913 81.3683C67.6045 79.2584 64.524 77.444 62.6252 75.7983C60.0511 73.6462 58.6586 70.4392 58.8274 67.1056C59.0806 61.9997 62.6674 56.514 68.7438 52.0833C70.8115 50.5642 73.0479 49.1716 75.2 47.7791C83.9349 42.2513 92.9652 36.5124 92.6698 23.5578C92.4588 13.8523 85.2008 7.26953 84.3569 6.55217H17.6004C16.7987 7.26953 9.49853 13.8523 9.28754 23.5578C8.99216 36.5546 18.0224 42.2513 26.7573 47.7791C28.9094 49.1294 31.1458 50.5642 33.2135 52.0833C39.29 56.514 42.9189 61.9997 43.1299 67.1056C43.2987 70.4392 41.9062 73.6462 39.3322 75.7983C37.4333 77.4862 34.3528 79.3006 30.7661 81.3683C22.1156 86.432 10.2581 93.3946 8.06381 103.395C5.27878 116.603 14.1824 126.52 15.1108 127.532Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.7115 44.6986C31.948 46.0911 34.2266 47.568 36.4209 49.1715C42.0332 53.2647 45.409 57.9908 47.4766 63.814C49.5021 69.5107 48.9535 75.5449 50.1773 81.4526C50.1351 82.1699 50.6837 82.7607 51.3588 82.8029C51.823 82.8451 52.245 82.5919 52.4981 82.2121C52.8357 81.7901 53.0045 81.2838 53.0467 80.7352C53.8063 76.0091 53.8063 71.5784 54.1017 66.7678C54.4392 60.6492 58.659 54.2352 65.5794 49.1715C67.7736 47.568 70.0523 46.1333 72.2888 44.6986C77.3103 41.5337 96.9321 27.482 83.8931 23.3044C81.108 22.4183 77.9854 22.6293 75.0316 22.9247L28.3612 26.9334C25.6605 27.1866 22.9177 27.3976 20.4281 28.3681C17.9384 29.3387 15.7863 31.0688 15.3644 33.263C14.5204 37.4828 26.0403 42.3777 29.7115 44.6986Z",
    fill: "url(#paint0_linear_561_7275)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.0572 102.13C84.6097 100.104 81.0651 99.0069 77.5205 99.1335C72.7522 99.3023 68.1105 100.864 63.3422 100.653C57.6877 100.399 52.3286 97.5722 46.6742 98.163C40.0491 98.7959 35.2386 103.86 28.8246 105.337C25.4066 106.138 21.6932 105.885 18.3596 106.898C14.4353 108.122 12.7052 111.455 13.1693 114.704C13.2959 115.717 16.081 123.692 17.6423 123.692H84.3565C87.7745 123.692 90.3486 109.05 90.011 106.982C89.6734 105.041 88.5763 103.353 87.0572 102.13Z",
    fill: "url(#paint1_linear_561_7275)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.292 0.982056H85.7069C87.1416 0.982056 88.3231 2.16358 88.3231 3.5983C88.3231 5.03301 87.1416 6.21454 85.7069 6.21454H16.292C14.8573 6.21454 13.6758 5.03301 13.6758 3.5983C13.6758 2.16358 14.8573 0.982056 16.292 0.982056Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.7069 6.46773H16.292C14.6885 6.50992 13.3382 5.2862 13.296 3.68269C13.2538 2.07919 14.4775 0.728864 16.081 0.686667C16.1654 0.686667 16.2076 0.686667 16.292 0.686667H85.7069C87.3104 0.644469 88.6607 1.8682 88.7029 3.4717C88.7451 5.07521 87.5214 6.42553 85.9179 6.46773C85.8335 6.50992 85.7491 6.50992 85.7069 6.46773ZM16.292 1.23524C14.9839 1.23524 13.9289 2.29017 13.9289 3.59829C13.9289 4.90642 14.9839 5.96135 16.292 5.96135H85.7069C87.015 5.96135 88.0699 4.90642 88.0699 3.59829C88.0699 2.29017 87.015 1.23524 85.7069 1.23524H16.292Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9424 127.828H87.0157C88.4504 127.828 89.632 129.009 89.632 130.444C89.632 131.879 88.4504 133.06 87.0157 133.06H14.9424C13.5077 133.06 12.3262 131.879 12.3262 130.444C12.3262 128.967 13.5077 127.828 14.9424 127.828Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.0157 133.313H14.9424C13.3389 133.356 11.9886 132.132 11.9464 130.528C11.9042 128.925 13.1279 127.575 14.7314 127.532C14.8158 127.532 14.858 127.532 14.9424 127.532H87.0157C88.6192 127.49 89.9695 128.714 90.0117 130.317C90.0539 131.921 88.8302 133.271 87.2267 133.313C87.1845 133.313 87.1001 133.313 87.0157 133.313ZM14.9424 128.081C13.6343 128.081 12.5793 129.136 12.5793 130.444C12.5793 131.752 13.6343 132.807 14.9424 132.807H87.0157C88.3238 132.807 89.3788 131.752 89.3788 130.444C89.3788 129.136 88.3238 128.081 87.0157 128.081H14.9424Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.924 84.8706C47.9407 84.8706 47.9407 91.4534 49.924 91.4534C51.9073 91.4534 51.9495 84.8706 49.924 84.8706Z",
    fill: "url(#paint2_linear_561_7275)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.4265 91.4958C52.6248 91.4958 52.6248 93.8166 53.4265 93.8166C54.2283 93.8166 54.2283 91.4958 53.4265 91.4958Z",
    fill: "url(#paint3_linear_561_7275)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.4891 38.538C39.3322 38.4536 30.2176 37.0611 21.4405 34.4448C21.3139 34.4026 21.2295 34.2338 21.2717 34.1072C21.3139 33.9806 21.4827 33.8963 21.6093 33.9385C21.9891 34.065 60.22 46.4711 80.728 27.3135C80.8546 27.1869 81.0234 27.1869 81.1078 27.3135C81.2344 27.44 81.2344 27.6088 81.1078 27.6932C72.0775 36.1327 59.6714 38.538 48.4891 38.538Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.8803 113.017C32.6645 113.017 25.5331 111.962 18.6127 109.936C18.4439 109.894 18.4017 109.725 18.4439 109.599C18.4861 109.472 18.6549 109.388 18.7815 109.43C18.9925 109.514 39.7959 116.308 58.5737 109.43L80.854 101.244C80.9806 101.201 81.1494 101.286 81.2338 101.412C81.276 101.539 81.1916 101.708 81.065 101.792L58.7847 109.936C52.3707 112.215 45.8301 113.017 39.8803 113.017Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.6892 102.636H67.6048C61.1908 101.032 49.9663 98.374 49.8819 98.3318C49.7131 98.2896 49.6287 98.163 49.6709 97.9942C49.7131 97.8254 49.8819 97.741 50.0085 97.7832C50.1351 97.8254 61.3174 100.484 67.7314 102.087C67.9002 102.13 67.9846 102.298 67.9424 102.425C67.9002 102.552 67.7736 102.636 67.6892 102.636Z",
    fill: "#E5E5E5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_561_7275",
    x: 0.978516,
    y: 0.685608,
    width: 100.043,
    height: 144.629,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.411765 0 0 0 0 0.411765 0 0 0 0 0.411765 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_561_7275"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_561_7275",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_561_7275",
    x1: 51.8056,
    y1: 22.6692,
    x2: 51.8056,
    y2: 82.8075,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0122131,
    stopColor: "#D0BDEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.280017,
    stopColor: "#5DCEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.735017,
    stopColor: "#A6E8FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5F2F3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_561_7275",
    x1: 51.5682,
    y1: 98.082,
    x2: 51.5682,
    y2: 123.692,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0122131,
    stopColor: "#D0BDEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.280017,
    stopColor: "#5DCEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.735017,
    stopColor: "#A6E8FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5F2F3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_561_7275",
    x1: 49.9319,
    y1: 84.8706,
    x2: 49.9319,
    y2: 91.4534,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0122131,
    stopColor: "#D0BDEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.280017,
    stopColor: "#5DCEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.735017,
    stopColor: "#A6E8FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5F2F3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_561_7275",
    x1: 53.4265,
    y1: 91.4958,
    x2: 53.4265,
    y2: 93.8166,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0122131,
    stopColor: "#D0BDEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.280017,
    stopColor: "#5DCEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.735017,
    stopColor: "#A6E8FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5F2F3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWait);
export default __webpack_public_path__ + "static/media/wait.eeb306d041929771bac036b66a14690e.svg";
export { ForwardRef as ReactComponent };